module.exports = __webpack_public_path__ + "static/media/logo-light.77b791fb.png";